// src/lib/axios.js
// Instancia axios configurada com interceptor de autenticacao JWT
// TODA chamada API autenticada deve usar este import em vez do axios global

import axios from 'axios';
import { supabase } from './supabase';

const api = axios.create();

// Interceptor: adiciona Bearer token automaticamente em todas as requests
api.interceptors.request.use(async (config) => {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (session?.access_token) {
      config.headers.Authorization = `Bearer ${session.access_token}`;
    }
  } catch (err) {
    console.warn('[API] Erro ao obter token de sessao:', err.message);
  }
  return config;
});

// Interceptor de resposta: se 401, tenta refresh do token e retry
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Se recebeu 401 e ainda nao tentou retry
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const { data: { session } } = await supabase.auth.refreshSession();
        if (session?.access_token) {
          originalRequest.headers.Authorization = `Bearer ${session.access_token}`;
          return api(originalRequest);
        }
      } catch (refreshError) {
        console.error('[API] Falha ao renovar token:', refreshError.message);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
